import React from "react";
//import { FaCloudDownload } from "react-icons/fa";

import profilePic from "../assets/images/profilepic.jpg";

const About = () => (
  <section id="about">
    <div className="row">
      <div className="three columns">
        <img className="profile-pic" src={profilePic} alt="" />
      </div>
      <div className="nine columns main-col">
        <h2>About Me</h2>
        <p>
	    <strong>I am an educator and a poet, 2nd dan blackbelt, software engineer, and social entrepreneur.</strong> My greatest concern is how to leverage breakthrough technology to address the human condition in illuminating ways. My classrooms are often attended by laughter, sometimes so much that they’re asked to pipe down.
	</p>
	<p>
	    <strong>I love what I do for work.</strong> I teach literature, computer science, math, and martial arts to ages between 5 and 65. I taught in high risk neighborhoods in New York City, including Rikers Island. And I love every minute, every lesson.
        </p>
      </div>
    </div>
  </section>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js